<!--
 * @Description: 百分比分析
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="165" :itemWidth="420 + 56">
      <div
        style="text-align: center"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 160px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            style="height: 120px !important"
            :value="item.value"
            :model-value="curItem.value"
            @change="onChangeFn(item.value)"
          >
            <component
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
              "
              :is="cmpName(item.value)"
              :tableHeaderList="topicData[0].table.header"
              :tableDataList="topicData[0].table.value"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div class="bi-tmpl-detail__right__cmpt__des">
      {{ topicData[0].resultSystem }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import PcModuleTaskPercent from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-task-percent';

import { BaseCard } from 'xrk-components';
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import _ from 'lodash';
import { topicData } from '../../../../mock/_topics';

const CHILD_KEY = '5_3';
const TYPE_MAPPING = {
  1: {
    value: 'pc-module-task-percent-1',
    moduleType: 'pc-module-task-percent-1'
  },
  2: {
    value: 'pc-module-task-percent-2',
    moduleType: 'pc-module-task-percent-2'
  },
  3: {
    value: 'pc-module-task-percent-3',
    moduleType: 'pc-module-task-percent-3'
  },
  4: {
    value: 'pc-module-task-percent-4',
    moduleType: 'pc-module-task-percent-4'
  },
  5: {
    value: 'pc-module-task-percent-5',
    moduleType: 'pc-module-task-percent-5'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleTaskPercent.filter(comp => comp.__name === name)[0];
};

const onChangeFn = _.debounce(val => {
  if (curItem.value === val) {
    onChange(null);
  } else {
    onChange(val);
  }
}, 0);
</script>
